module.exports = __webpack_public_path__ + "static/media/background.64d37a98.jpg";